import UltMeta, { Meta } from "./UltMeta/index";

class SaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
    COMMIT_RECEIPT = new Meta(3, "提交并生成签收单");
    COMMIT_AND_RECEIPT_RECONCILIATION = new Meta(4, "提交并生成签收单和对账单");
}

export const SAVE_TYPE = new SaveType();

/**
 * 发货状态
 */
class Status extends UltMeta {
    DRAFT = new Meta(6, "草稿");
    WAIT_DELIVER = new Meta(1, "待发货");
    DELIVERING = new Meta(2, "发货中");
    DELIVER_COMPLETE = new Meta(3, "发货完成");
    DELIVER_CANCEL = new Meta(4, "发货取消");
    DELIVER_INVALID = new Meta(5, "已作废");
}

export const STATUS = new Status();

class StatusPC extends UltMeta {
    DRAFT = new Meta(6, "草稿");
    IN_TRANSIT = new Meta(2, "提货中");
    FINISHED = new Meta(3, "提货完成");
    CANCEL = new Meta(4, "提货取消");
    DELIVER_INVALID = new Meta(5, "已作废");
}

export const STATUS_PC = new StatusPC();

/**
 *
 */
class ReceiveWay extends UltMeta {
    MERGE = new Meta(1, "合并签收");
    SEPARATE = new Meta(2, "签收");
}

export const RECEIVE_WAY = new ReceiveWay();

/**
 * 发货方式
 */
class DeliverWay extends UltMeta {
    SHIPPING = new Meta(1, "船运");
    CAR = new Meta(2, "汽运");
    // AIRPLANE = new Meta(3, "航运");
    RAILWAY = new Meta(4, "铁路");
    SELF_PICKUP = new Meta(5, "自提");
    // NONE = new Meta(6, "无");
}

export const DELIVER_WAY = new DeliverWay();

/**
 * 是否发货
 */
class HasDeliver extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}
export const HAS_DELIVER = new HasDeliver();

/**
 * 是否发货-列表展示
 */
class ShowHasDeliver extends UltMeta {
    YES = new Meta(2, "是");
    NO2 = new Meta(1, "否");
    NO = new Meta(0, "否");
}

export const SHOW_HAS_DELIVER = new ShowHasDeliver();

/**
 * 签收状态
 */
class SignStatus extends UltMeta {
    NOT_STARTED = new Meta(1, "未签收");
    IN_PROGRESS = new Meta(2, "签收中");
    COMPLETED = new Meta(3, "签收完成");
    // 下游签收单处于作废流程中时，发货/提货单展示为作废中。
    INVALIDING = new Meta(4, "作废中");
}
export const SIGN_STATUS = new SignStatus();

/**
 * 根据后端派生签收状态获取发货/提货签收状态展示文案。
 */
export const getDeliveryGoodsSignStatusText = (isDeliveryFinished: boolean, signStatus?: number | null, defaultText = "--") => {
    if (!isDeliveryFinished) return defaultText;
    return SIGN_STATUS.getIntroByCode(signStatus ?? undefined) || defaultText;
};

/**
 * 判断发货/提货单是否可按未签收处理，避免作废中被误作为未签收。
 */
export const isDeliveryGoodsUnsigned = (isDeliveryFinished: boolean, signStatus?: number | null) => {
    return isDeliveryFinished && signStatus === SIGN_STATUS.NOT_STARTED.code;
};
